import { Validator } from "helpers/validator";
import { REGEX_SCIENTIFIC_NOTATION } from "../constants";
import { IIdentifierFields, IUPCData, IUPCDataError, UPCRuleType } from "../types";
import { formatMessage } from "lib/globalize-util";
import { SIZE_COLUMN_FIELD, UPC_COLUMN_FIELD } from "helpers/utils/constants";

export class UPCScientificRule extends Validator<IUPCData[], IUPCDataError> {
    private readonly identifierFields: IIdentifierFields[];
    private readonly sizeField = SIZE_COLUMN_FIELD.key;
    private readonly upcField = UPC_COLUMN_FIELD.key;

    constructor(identifierFields: IIdentifierFields[]) {
        super();

        this.identifierFields = identifierFields;
    }

    validate(model: IUPCData[], errors: IUPCDataError): IUPCDataError {
        const scientificNotationErrorType = UPCRuleType.UPCScientificRule;
        const hasRequiredColumnsError = !!errors[UPCRuleType.RequiredColumnsRule];

        if (hasRequiredColumnsError) {
            return errors;
        }

        const validationErrors = model.reduce((errors, row) => {
            const size = row[this.sizeField]?.value.toString();
            const rowIdentifiers = this.identifierFields.reduce((acc, identifier) => {
                const rowValue = row[identifier.key]?.value;
                if (rowValue) {
                    acc[identifier.key] = rowValue;
                }
                return acc;
            }, {});

            const upcValue = row[this.upcField]?.value?.toString();

            if (upcValue.length && REGEX_SCIENTIFIC_NOTATION.test(upcValue)) {
                const productIdentifierFields = Object.values(rowIdentifiers).join("-");
                const productSize = size.toUpperCase();
                const errorMessage = formatMessage("|product| Your UPC appears to be saved in scientific notation.", {
                    product: `${productIdentifierFields}-${productSize}:`,
                });

                if (errors[scientificNotationErrorType]) {
                    errors[scientificNotationErrorType].push(errorMessage);
                } else {
                    errors[scientificNotationErrorType] = [errorMessage];
                }
            }

            return errors;
        }, errors);

        return super.validate(model, validationErrors);
    }
}
